import { useCallback, useMemo } from 'react';
import find from 'lodash/find';
import isArray from 'lodash/isArray';

import { TagID } from '../../tagsTypes';

import { useProjectPaginatedTags } from '../../hooks/useProjectPaginatedTags';

import {
  MultiSelectChangeCallbackType,
  MultiSelectDataType
} from '../../../../helpers/MultiSelect/types';
import { MultiSelect, MultiSelectProps } from '../../../../helpers/MultiSelect';

interface TagsMultiSelectProps {
  value: TagID[];
  autoFocus?: boolean;
  onChange: (value: TagID[]) => void;
}

function TagsMultiSelect({
  value,
  autoFocus,
  onChange
}: TagsMultiSelectProps & MultiSelectProps) {
  const { tags, tagsLoading, tagsError } = useProjectPaginatedTags();

  const tagsData = useMemo<MultiSelectDataType[]>(() => {
    return tags.map((tag) => ({ value: tag.id, label: tag.localizedName }));
  }, [tags]);

  const handleChange = useCallback<MultiSelectChangeCallbackType>(
    (value: MultiSelectDataType) => {
      onChange(isArray(value) ? value.map((item) => item.value) : []);
    },
    [onChange]
  );

  const multiSelectValue = useMemo<MultiSelectDataType[]>(() => {
    return isArray(value)
      ? value.map((item) => find(tagsData, ['value', item]))
      : [];
  }, [value, tagsData]);

  return (
    <MultiSelect
      error={tagsError}
      inputWrapperClassName="block"
      onChange={handleChange}
      value={multiSelectValue}
      multi={true}
      isSearchable={true}
      optionsLoading={tagsLoading}
      isLoading={tagsLoading}
      data={tagsData}
      classNamePrefix="av_multi_select"
      autoFocus={autoFocus}
    />
  );
}

export default TagsMultiSelect;
